(function () {
  console.log("TM WIP DESIGNS JS LOADED");

  var APP_ORIGIN = "https://designer.turtlememory.com";
  var LIST_API = APP_ORIGIN + "/api/list-wip-designs";

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function formatDate(iso) {
    if (!iso) return "";
    try {
      return new Date(iso).toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    } catch (_) {
      return "";
    }
  }

  function getRoot() {
    return document.getElementById("tm-wip-root");
  }

  function openModal() {
    var root = getRoot();
    if (!root) return;
    var overlay = root.querySelector(".tm-wip-overlay");
    if (overlay) overlay.hidden = false;
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    var root = getRoot();
    if (!root) return;
    var overlay = root.querySelector(".tm-wip-overlay");
    if (overlay) overlay.hidden = true;
    document.body.style.overflow = "";
  }

  function setModalContent(html) {
    var root = getRoot();
    if (!root) return;
    var body = root.querySelector(".tm-wip-body");
    if (body) body.innerHTML = html;
  }

  async function fetchWipList(shop, customerId) {
    var res = await fetch(LIST_API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ shop: shop, customer_id: customerId }),
    });
    var data = await res.json();
    if (!res.ok) {
      throw new Error(data.error || "Could not load designs");
    }
    return data.designs || [];
  }

  function continueDesign(item) {
    var url = String(item && item.personalize_url || "").trim();
    if (!url) {
      throw new Error(
        "This design could not be found. Please start again from the product page or contact support."
      );
    }
    window.location.href = url;
  }

  function renderList(designs) {
    if (!designs.length) {
      setModalContent(
        '<p class="tm-wip-empty">You don\u2019t have any albums in progress.</p>'
      );
      return;
    }

    var html = '<ul class="tm-wip-list">';
    designs.forEach(function (item) {
      var thumb = item.thumbnail_url
        ? '<img class="tm-wip-thumb" src="' +
          escapeHtml(item.thumbnail_url) +
          '" alt="" loading="lazy" />'
        : '<div class="tm-wip-thumb tm-wip-thumb--placeholder" aria-hidden="true"></div>';
      var meta = item.updated_at
        ? "Updated " + escapeHtml(formatDate(item.updated_at))
        : "";
      var statusLine = item.status_label
        ? escapeHtml(item.status_label)
        : "";
      html +=
        '<li class="tm-wip-item">' +
        thumb +
        '<div class="tm-wip-item-text">' +
        '<p class="tm-wip-item-title">' +
        escapeHtml(item.title) +
        "</p>" +
        (meta ? '<p class="tm-wip-item-meta">' + meta + "</p>" : "") +
        (statusLine ? '<p class="tm-wip-item-meta">' + statusLine + "</p>" : "") +
        "</div>" +
        '<button type="button" class="tm-wip-continue" data-design-id="' +
        escapeHtml(item.design_id) +
        '">Continue</button>' +
        "</li>";
    });
    html += "</ul>";
    setModalContent(html);

    getRoot().querySelectorAll(".tm-wip-continue").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var designId = btn.getAttribute("data-design-id");
        var item = designs.find(function (d) {
          return d.design_id === designId;
        });
        if (!item) return;
        try {
          continueDesign(item);
        } catch (err) {
          console.error("[tm-wip]", err);
          alert(err.message || "Something went wrong. Please try again.");
        }
      });
    });
  }

  document.addEventListener("click", function (e) {
    var openBtn = e.target.closest(".tm-wip-open-btn");
    if (openBtn) {
      e.preventDefault();
      var root = getRoot();
      if (!root) return;
      var shop = root.dataset.shop;
      var customerId = root.dataset.customerId;
      if (!customerId) {
        alert("Please log in to view your in-progress albums.");
        return;
      }

      openModal();
      setModalContent(
        '<p class="tm-wip-loading"><span class="tm-wip-spinner"></span> Loading your albums…</p>'
      );

      fetchWipList(shop, customerId)
        .then(function (designs) {
          renderList(designs);
        })
        .catch(function (err) {
          setModalContent(
            '<p class="tm-wip-error">' +
              escapeHtml(err.message || "Could not load designs.") +
              "</p>"
          );
        });
      return;
    }

    if (e.target.closest(".tm-wip-close")) {
      closeModal();
      return;
    }
    var overlayEl = e.target.closest(".tm-wip-overlay");
    if (overlayEl && e.target === overlayEl) {
      closeModal();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeModal();
  });
})();
